import lodash from 'lodash';
export default {
  install: function install(Vue) {
    Vue.prototype._ = lodash;
  }
};